module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/string_decoder/~/safe-buffer/browser.js
// module id = 1655
// module chunks = 1